<ion-header class="ion-no-border" [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start" class="navbar-back">
      <ion-button (click)="closeModal()">
        <ion-icon name="chevron-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title class="ion-text-center navbar-title">Kontakt bearbeiten</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content fullscreen="true">
  <div class="basepadding">
  <form (ngSubmit)="onSubmit()" novalidate>
    <!-- Firmenname -->
    <h3>Firma</h3>
    <ion-item>
      <ion-label position="stacked">Firmenname</ion-label>
      <ion-input [(ngModel)]="formData.companyName" name="companyName" required></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="stacked">Webseite</ion-label>
      <ion-input [(ngModel)]="formData.website" name="website" type="url"></ion-input>
    </ion-item>

    <!-- Kontaktperson -->
    <h3>Kontaktperson</h3>
    <ion-item>
      <ion-label position="stacked">Anrede</ion-label>
      <ion-input [(ngModel)]="formData.contactPerson.salutation" name="salutation"></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="stacked">Vorname</ion-label>
      <ion-input [(ngModel)]="formData.contactPerson.firstName" name="firstName" required></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="stacked">Nachname</ion-label>
      <ion-input [(ngModel)]="formData.contactPerson.lastName" name="lastName" required></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="stacked">E-Mail</ion-label>
      <ion-input [(ngModel)]="formData.contactPerson.emailAddress" name="emailAddress" type="email" required></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="stacked">Telefon</ion-label>
      <ion-input [(ngModel)]="formData.contactPerson.phoneNumber" name="phoneNumber" required></ion-input>
    </ion-item>

    <!-- Adresse -->
    <h3>Adresse</h3>
    <ion-item>
      <ion-label position="stacked">Adresszusatz</ion-label>
      <ion-input [(ngModel)]="formData.address.supplement" name="supplement" required></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="stacked">Straße</ion-label>
      <ion-input [(ngModel)]="formData.address.street" name="street" required></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="stacked">PLZ</ion-label>
      <ion-input [(ngModel)]="formData.address.zip" name="zip" required></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="stacked">Stadt</ion-label>
      <ion-input [(ngModel)]="formData.address.city" name="city" required></ion-input>
    </ion-item>

    <!-- Lieferadresse -->
    <h3>Lieferadresse</h3>
    <ion-item>
      <ion-label position="stacked">Firmenname</ion-label>
      <ion-input [(ngModel)]="formData.delivery.companyName" name="deliveryCompanyName"></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="stacked">Kontaktperson</ion-label>
      <ion-input [(ngModel)]="formData.delivery.contactPerson" name="deliveryContactPerson"></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="stacked">Adresszusatz</ion-label>
      <ion-input [(ngModel)]="formData.delivery.supplement" name="deliverySupplement"></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="stacked">Straße</ion-label>
      <ion-input [(ngModel)]="formData.delivery.street" name="deliveryStreet"></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="stacked">PLZ</ion-label>
      <ion-input [(ngModel)]="formData.delivery.zip" name="deliveryZip"></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="stacked">Stadt</ion-label>
      <ion-input [(ngModel)]="formData.delivery.city" name="deliveryCity"></ion-input>
    </ion-item>

    <!-- Notiz -->
    <ion-item>
      <ion-label position="stacked">Notiz</ion-label>
      <ion-textarea [(ngModel)]="formData.note" name="note"></ion-textarea>
    </ion-item>

    <div class="basepadding">
    <!-- Bestätigen-Button -->
    <ion-button expand="block" type="submit" color="primary">Speichern</ion-button>
  </div>
  </form>
  </div>
</ion-content>
